import React, { useEffect, useState } from "react";
import { SimpleItem } from 'devextreme-react/form';
import { NumberBox, TextBox } from "devextreme-react";
import { LVForm } from "../../../Basicos/LVForm";

function LVConceptoObservaciones({ DatosConceptoObservaciones, setDatosConceptoObservaciones }) {

  const [concepto, setConcepto] = useState(DatosConceptoObservaciones.concepto);
  const [observaciones, setObservaciones] = useState(DatosConceptoObservaciones.observaciones);

  const handleConceptoOnValueChanged = async (e) => {
    setConcepto(e.value)
  };

  const handleObservacionesOnValueChanged = async (e) => {
    setObservaciones(e.value)
  };

  useEffect(() => {
    setDatosConceptoObservaciones({
      concepto: concepto,
      observaciones: observaciones
    })
  }, [concepto, observaciones]);

  useEffect(() => {
    setConcepto(DatosConceptoObservaciones.concepto)
    setObservaciones(DatosConceptoObservaciones.observaciones)
  }, [DatosConceptoObservaciones]);

  return (
    <div className="LV-GroupBox-div LV-FlexContainer">
      <TextBox
        width={'40%'}
        label="Concepto"
        value={concepto}
        onValueChanged={handleConceptoOnValueChanged} />
      <TextBox
        width={'60%'}
        label="Observaciones"
        value={observaciones}
        onValueChanged={handleObservacionesOnValueChanged} />
    </div>
  );
}

export default LVConceptoObservaciones

